module.exports = __webpack_public_path__ + "images/emoji/bangbang.ccc4eb97c25da018b1dd.png";